(function() { window.GUID_3db4aad1_c902_46bf_9046_0f7bbcf21c1c = { getGuid: function() { return "3db4aad1-c902-46bf-9046-0f7bbcf21c1c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class EventsLinker extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            get EventsCounter() {
                return this.$control.find(".events-linker-event-container").length;
            }
            get EventsLinkedCounter() {
                return this.$control.find(".yes-button.active").length;
            }
            OnDispose() {
                this.$control.off("dropdown-picker-selection-changed");
                this.$control.remove();
            }
            OnControlInstantiation(params) {
                const me = this;
                me.controlId = params[0];
                me.$control = $(`#${params[0]}`);
                me.changeEntitySportEventLinkUrl = params[1];
                me.appendNewPlayerToPlayersToLinkUrl = params[2];
                me.findPlayerUrl = params[3];
                me.playerProfileModalUrl = params[4];
                me.eventLinkDetailsModalUrl = params[5];
                me.updateEventNotificationSubscription = params[6];
                me.$scrollablePart = this.$Control.find(".events-linker-body");
            }
            OnBindEvents() {
                const me = this;
                CS.Controls.DropDownPicker.Events.SelectionChanged({
                    selector: "#autocomplete-find-players-events-linker",
                    callback: (picker, e) => {
                        const dataToSend = {
                            personaId: e.data[0].value,
                        };
                        CS.Ajax.Post(me.appendNewPlayerToPlayersToLinkUrl, dataToSend, function (response) {
                            me.$scrollablePart[0].innerHTML = response;
                            me.$scrollablePart.scrollTop();
                        });
                    },
                });
                // TODO :   Vérifier pourquoi l'event du bouton n'est pas trigger sur les évènements appendés via ajax.
                //          Ça fonctionne quand même en attendant avec "$control.offon", mais c'est seulement un fix temporaire.
                //CS.Controls.Button.Events.Clicked({
                //    selector: ".player-profile-button",
                //    callback: (button, e) => {
                //        const $button = button.$Control,
                //            buttonData = e.data.extraData as Controls.EventsLinker.DataModels.PlayersLinkerButtonData,
                //            playerId = buttonData.PlayerId,
                //            eventId = buttonData.EventId,
                //            ajaxData = {
                //                playerId,
                //                eventId
                //            };
                //        Popup.ShowAjaxModal(me.playerProfileModalUrl, ajaxData,
                //            ({popup}) => {
                //                // OnLoad
                //            }, ({popup}) => {
                //                // OnClose
                //            });
                //    }
                //});
                //CS.Controls.Button.Events.Clicked({
                //    selector: ".events-linker .yes-button, .events-linker .no-button",
                //    callback: (button, e) => {
                //        const $button = button.$Control,
                //            buttonData = e.data.extraData as Controls.EventsLinker.DataModels.PlayersLinkerButtonData,
                //            $eventContainer = $button.closest(".events-linker-event-container"),
                //            playerId = buttonData.PlayerId,
                //            eventId = buttonData.EventId,
                //            links = new Array<any>(),
                //            link = {
                //                EntityBaseId: playerId,
                //                SportEventId: eventId,
                //                LinkState: $button.hasClass("yes-button") ? 1 : 2
                //            };
                //        let isLinked = false;
                //        if (!$button.hasClass("active")) {
                //            $button.addClass("active");
                //            if ($button.hasClass("yes-button")) {
                //                $eventContainer.find(".no-button").removeClass("active");
                //                isLinked = true;
                //            }
                //            else {
                //                $eventContainer.find(".yes-button").removeClass("active");
                //            }
                //            links.push(link);
                //            me.postLinks(me.changeEntitySportEventLinkUrl, links, () => {
                //                me.Trigger<IEventsLinkerEventLinkStateChangeData>(EventsLinker.EventNames.EventLinkStateChange, { jqueryEventObject: e.jqueryEventObject, data: { entityBaseId: playerId, eventId, isLinked } });
                //            });
                //        }
                //    }
                //});
                CS.Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: ".notif-checkbox",
                    callback: (control, params) => {
                        let eventId = control.$Control
                            .closest(".events-linker-event-container")
                            .data("sporteventid");
                        let isSubscribed = control.IsChecked;
                        let data = {
                            eventId: eventId,
                            isSubscribed: isSubscribed,
                        };
                        control.$Control
                            .parents(".event-notifications")
                            .find(".toggle-warning")
                            .toggleClass("hide");
                        CS.Ajax.Post(me.updateEventNotificationSubscription, data, function (response) { });
                    },
                });
                me.$control.offon(`click.${me.controlId}`, (e) => {
                    const $target = $(e.target), $button = $target.closest("button");
                    if ($button.length > 0) {
                        if ($button.hasClass("event-link-button") ||
                            $button.hasClass("unlink-button")) {
                            const buttonData = $button.data("html"), $eventContainer = $button.closest(".events-linker-event-container"), playerId = buttonData.PlayerId, linkedEventId = buttonData.LinkedEventId, verifiedInPopup = $button.closest("#popup-events-linker").length == 1, links = new Array();
                            let link = {
                                EntityBaseId: playerId,
                                SportEventId: linkedEventId,
                                verifiedInPopup,
                                LinkState: 2,
                            };
                            let isLinked = false;
                            if ($button.hasClass("event-link-button")) {
                                link.LinkState = $button.hasClass("yes-button") ? 1 : 2;
                                if (!$button.hasClass("active")) {
                                    $button.addClass("active");
                                    if ($button.hasClass("yes-button")) {
                                        $button.parent().find(".no-button").removeClass("active");
                                        $eventContainer.find(".no-all-button").removeClass("active");
                                        isLinked = true;
                                        if ($button.hasClass("yes-all-button")) {
                                            let allYes = $eventContainer.find(".yes-button:not(.yes-all-button)");
                                            allYes.addClass("active");
                                            allYes.each((i, e) => {
                                                $eventContainer.find(".no-button").removeClass("active");
                                                let yesButtonData = $(e).data("html");
                                                let newLink = {
                                                    EntityBaseId: link.EntityBaseId,
                                                    SportEventId: yesButtonData.LinkedEventId,
                                                    LinkState: link.LinkState,
                                                    verifiedInPopup,
                                                };
                                                links.push(newLink);
                                            });
                                        }
                                    }
                                    else {
                                        $button.parent().find(".yes-button").removeClass("active");
                                        $eventContainer.find(".yes-all-button").removeClass("active");
                                        if ($button.hasClass("no-all-button")) {
                                            let allNo = $eventContainer.find(".no-button:not(.no-all-button)");
                                            allNo.addClass("active");
                                            allNo.each((i, e) => {
                                                $eventContainer.find(".yes-button").removeClass("active");
                                                let noButtonData = $(e).data("html");
                                                let newLink = {
                                                    EntityBaseId: link.EntityBaseId,
                                                    SportEventId: noButtonData.LinkedEventId,
                                                    LinkState: link.LinkState,
                                                    verifiedInPopup,
                                                };
                                                links.push(newLink);
                                            });
                                        }
                                    }
                                    if ($eventContainer.find(".yes-button:not(.yes-all-button)")
                                        .length ==
                                        $eventContainer.find(".yes-button.active:not(.yes-all-button)").length) {
                                        $eventContainer.find(".yes-all-button").addClass("active");
                                    }
                                    if ($eventContainer.find(".no-button:not(.no-all-button)")
                                        .length ==
                                        $eventContainer.find(".no-button.active:not(.no-all-button)")
                                            .length) {
                                        $eventContainer.find(".no-all-button").addClass("active");
                                    }
                                }
                            }
                            if (links.length == 0) {
                                links.push(link);
                            }
                            me.postLinks(me.changeEntitySportEventLinkUrl, links, (returnUrl, content, success) => {
                                var _a;
                                if (success == false) {
                                    isLinked = false;
                                    $button.parent().find(".yes-button").removeClass("active");
                                    //TODO Fixer. c'est pas parfait.
                                }
                                me.Trigger(EventsLinker.EventNames.EventLinkStateChange, {
                                    jqueryEventObject: e,
                                    data: {
                                        entityBaseId: playerId,
                                        linkedEventId,
                                        isLinked,
                                        $eventContainer,
                                    },
                                });
                                if ($button.hasClass("unlink-button")) {
                                    $eventContainer.remove();
                                }
                                if (returnUrl && ((_a = CS.Controls.Popup.CurrentModal) === null || _a === void 0 ? void 0 : _a.Data)) {
                                    CS.Controls.Popup.CurrentModal.Data.returnUrl = returnUrl;
                                    CS.Controls.Popup.CurrentModal.Data.childModal = content;
                                }
                            });
                        }
                        else if ($button.hasClass("player-profile-button")) {
                            const buttonData = $button.data("html"), linkedPlayerId = buttonData.PlayerId, linkedEventId = buttonData.LinkedEventId, ajaxData = {
                                linkedPlayerId,
                                linkedEventId,
                            };
                            Controls.Popup.ShowAjaxModal(me.playerProfileModalUrl, ajaxData, ({ popup }) => {
                                // OnLoad
                            }, ({ popup }) => {
                                // OnClose
                            });
                        }
                        else if ($button.hasClass("event-link-details-button")) {
                            const buttonData = $button.data("html"), linkedPlayerId = buttonData.PlayerId, linkedEventId = buttonData.LinkedEventId, ajaxData = {
                                linkedPlayerId,
                                linkedEventId,
                            };
                            Controls.Popup.ShowAjaxModal(me.eventLinkDetailsModalUrl, ajaxData, ({ popup }) => {
                                // OnLoad
                            }, ({ popup }) => {
                                // OnClose
                            });
                        }
                    }
                });
            }
            postLinks(url, links, callback) {
                let data = {
                    links: links,
                };
                CS.Ajax.Post(url, data, function (response) {
                    if (callback) {
                        callback.call(this, response === null || response === void 0 ? void 0 : response.returnUrl, response === null || response === void 0 ? void 0 : response.popup, response === null || response === void 0 ? void 0 : response.success);
                    }
                });
            }
        }
        Controls.EventsLinker = EventsLinker;
        (function (EventsLinker) {
            class Events {
                static EventLinkStateChange(param) {
                    Controls.RegisterEvent(EventsLinker, EventNames.EventLinkStateChange, param);
                }
            }
            EventsLinker.Events = Events;
            class EventNames {
            }
            EventNames.EventLinkStateChange = "events-linker-event-link-state-change";
            EventsLinker.EventNames = EventNames;
        })(EventsLinker = Controls.EventsLinker || (Controls.EventsLinker = {}));
        class EventsLinkerChoiceConfirmationPopup {
            static show(url) {
                return new Promise((resolve, reject) => {
                    Controls.Popup.ShowAjaxModal(url, {}, ({ popup, isPopup }) => {
                        if (isPopup) {
                            popup.$Control.offon("click.playerclicked", ".players .player", (e) => EventsLinkerChoiceConfirmationPopup.handlePlayerClick(e, popup));
                            popup.$Control.offon("click.actionclicked", ".actions .action", (e) => EventsLinkerChoiceConfirmationPopup.handleActionClick(e, popup));
                            popup.$Control.offon("click.radioclicked", ".cant-link-to-player input[type='radio']", (e) => EventsLinkerChoiceConfirmationPopup.handleReasonClick(e, popup));
                            popup.$Control.offon("keyup.radioclicked", ".cant-link-to-player input[type='text']", (e) => EventsLinkerChoiceConfirmationPopup.handleReasonText(e, popup));
                            popup.$Control.offon("click.submitclicked", "#button-events-linker-choice-confirmation-popup-submit", (e) => EventsLinkerChoiceConfirmationPopup.handleSubmitClick(e, popup));
                        }
                    }, ({ popup }) => {
                        if (popup.Proceed) {
                            console.log(popup.Proceed);
                            console.log(popup.CustomData);
                            resolve(popup.CustomData);
                        }
                        else {
                            reject();
                        }
                    }, true);
                });
            }
            static handlePlayerClick(e, popup) {
                const $target = $(e.target);
                const $currentTarget = $(e.currentTarget);
                const isWithinCheckbox = $target.closest(".player__checkbox").length > 0;
                if (isWithinCheckbox) {
                    return;
                }
                const $checkSVG = $currentTarget.find(".check-svg");
                if (!$checkSVG.length) {
                    return;
                }
                $checkSVG.click();
                EventsLinkerChoiceConfirmationPopup.updatePlayerSelection(popup);
            }
            static handleActionClick(e, popup) {
                const $currentTarget = $(e.currentTarget);
                const isSelected = $currentTarget.hasClass("selected");
                const $siblings = $currentTarget.siblings(".action");
                const $submitButton = popup.$Control.find("#button-events-linker-choice-confirmation-popup-submit");
                const $warning = popup.$Control.find(".warning__label");
                $siblings.removeClass("selected");
                const selectedPlayersCount = EventsLinkerChoiceConfirmationPopup.getSelectedPlayersCount(popup);
                if (selectedPlayersCount === 0) {
                    $currentTarget.removeClass("selected");
                    if ($submitButton.length) {
                        CS.Helper.disableButton($submitButton);
                    }
                    $warning.hide();
                    return;
                }
                if (isSelected) {
                    $currentTarget.removeClass("selected");
                }
                else {
                    $currentTarget.addClass("selected");
                }
                const $allActions = popup.$Control.find(".actions .action");
                const anySelected = $allActions.hasClass("selected");
                if (anySelected) {
                    const actionType = EventsLinkerChoiceConfirmationPopup.getSelectedActionType(popup);
                    $warning.show();
                    if (actionType == "link") {
                        CS.Helper.enableButton($submitButton);
                    }
                    else if (actionType == "sendrequest") {
                        if ($warning.find(".cant-link-to-player")) {
                            CS.Helper.disableButton($submitButton);
                            let $selectedRadio = $warning.find("input[type='radio']:checked");
                            if ($selectedRadio.length) {
                                if ($selectedRadio[0].id != "other" || $warning.find("input[type='text']").val()) {
                                    CS.Helper.enableButton($submitButton);
                                }
                            }
                        }
                        else {
                            CS.Helper.enableButton($submitButton);
                        }
                    }
                    else {
                        $warning.hide();
                        CS.Helper.enableButton($submitButton);
                    }
                }
                else {
                    CS.Helper.disableButton($submitButton);
                    $warning.hide();
                }
            }
            static handleReasonClick(e, popup) {
                const $currentTarget = $(e.currentTarget);
                const $submitButton = popup.$Control.find("#button-events-linker-choice-confirmation-popup-submit");
                const $warning = popup.$Control.find(".warning__label");
                const selectedPlayersCount = EventsLinkerChoiceConfirmationPopup.getSelectedPlayersCount(popup);
                if (selectedPlayersCount === 0) {
                    $currentTarget.removeClass("selected");
                    if ($submitButton.length) {
                        CS.Helper.disableButton($submitButton);
                    }
                    $warning.hide();
                    return;
                }
                if ($warning.find(".cant-link-to-player")) {
                    CS.Helper.disableButton($submitButton);
                    let $selectedRadio = $warning.find("input[type='radio']:checked");
                    if ($selectedRadio.length) {
                        if ($selectedRadio[0].id != "other" || $warning.find("input[type='text']").val()) {
                            CS.Helper.enableButton($submitButton);
                        }
                    }
                }
                else {
                    CS.Helper.enableButton($submitButton);
                }
            }
            static handleReasonText(e, popup) {
                const $submitButton = popup.$Control.find("#button-events-linker-choice-confirmation-popup-submit");
                const $warning = popup.$Control.find(".warning__label");
                if ($warning.find(".cant-link-to-player")) {
                    CS.Helper.disableButton($submitButton);
                    let $selectedRadio = $warning.find("input[type='radio']:checked");
                    if ($selectedRadio.length) {
                        if ($selectedRadio[0].id != "other" || $warning.find("input[type='text']").val()) {
                            CS.Helper.enableButton($submitButton);
                        }
                    }
                }
                else {
                    CS.Helper.enableButton($submitButton);
                }
            }
            static handleSubmitClick(e, popup) {
                const $currentTarget = $(e.currentTarget);
                const isDisabled = $currentTarget.hasClass("disabled");
                if (isDisabled) {
                    Controls.Snackbar.Show({
                        Id: "events-linker-choice-confirmation-popup-submit",
                        Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                        Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                        Type: CS.Enumeration.SnackbarType.Info,
                        AutoHideDuration: 3000,
                        Message: JSRess.PleaseSelectAnActionBeforeContinuing,
                    });
                    return;
                }
                const links = EventsLinkerChoiceConfirmationPopup.getLinks(popup);
                const $cantLink = popup.$Control.find(".cant-link-to-player");
                const reason = $cantLink.find("input[type='radio']:checked").attr("id");
                const reasonDetails = $cantLink.find("#reason-details").val();
                const actionType = EventsLinkerChoiceConfirmationPopup.getSelectedActionType(popup);
                popup.Proceed = true;
                popup.CustomData = {
                    links,
                    actionType,
                    reason,
                    reasonDetails
                };
                if (actionType == "sendrequest") {
                    //Snackbar.Show({
                    //    Id: "send-request-warning",
                    //    Message: "Your account is NOT linked.  A request was sent for approval.",
                    //    Type: CS.Enumeration.SnackbarType.Warning,
                    //    Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                    //    Animation: CS.Enumeration.SnackbarAnimation.Slide,
                    //    AutoHideDuration: 3000,
                    //});
                }
                popup.Close();
            }
            static getLinks(popup) {
                const result = [];
                const $players = popup.$Control.find(".players .player");
                $players.each((index, player) => {
                    const $player = $(player);
                    const $checkbox = $player.find(".checkbox.control-cs");
                    const isChecked = $checkbox.hasClass("checked");
                    if (isChecked) {
                        const EntityBaseId = $player.attr("data-entity-base-id");
                        const SportEventId = $player.attr("data-sport-event-id");
                        const LinkState = $player.attr("data-link-state");
                        result.push({
                            EntityBaseId,
                            SportEventId,
                            LinkState,
                        });
                    }
                });
                return result;
            }
            static getSelectedActionType(popup) {
                const $actions = popup.$Control.find(".actions .action");
                const $selectedAction = $actions.filter(".selected");
                if (!$selectedAction.length) {
                    return null;
                }
                const actionType = $selectedAction.attr("data-action-type");
                return actionType;
            }
            static updatePlayerSelection(popup) {
                const counter = EventsLinkerChoiceConfirmationPopup.getSelectedPlayersCount(popup);
                if (counter === 0) {
                    const $submitButton = popup.$Control.find("#button-events-linker-choice-confirmation-popup-submit");
                    if ($submitButton.length) {
                        CS.Helper.disableButton($submitButton);
                    }
                    const $actions = popup.$Control.find(".actions .action");
                    if ($actions.length) {
                        $actions.removeClass("selected");
                    }
                }
                const $counterLabel = popup.$Control.find(".selected-players-counter__label");
                if (!$counterLabel.length) {
                    return;
                }
                $counterLabel.text(CS.Helper.formatString(JSRess.XPlayersSelected, counter));
            }
            static getSelectedPlayersCount(popup) {
                const $allPlayers = popup.$Control.find(".players .player");
                if (!$allPlayers.length) {
                    return 0;
                }
                let counter = 0;
                $allPlayers.each((i, e) => {
                    const $player = $(e);
                    const $checkbox = $player.find(".checkbox.control-cs");
                    const isChecked = $checkbox.hasClass("checked");
                    if (isChecked) {
                        counter++;
                    }
                });
                return counter;
            }
        }
        Controls.EventsLinkerChoiceConfirmationPopup = EventsLinkerChoiceConfirmationPopup;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=events-linker.js.map
